import { render, staticRenderFns } from "./ExpertNew.vue?vue&type=template&id=1f741d50&scoped=true&"
import script from "./ExpertNew.vue?vue&type=script&lang=js&"
export * from "./ExpertNew.vue?vue&type=script&lang=js&"
import style0 from "./ExpertNew.vue?vue&type=style&index=0&id=1f741d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f741d50",
  null
  
)

export default component.exports